import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Thumbs, A11y } from 'swiper/modules';
import type { MediaItem } from '../../../types/animatronic';
import MediaViewer from './MediaViewer';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

interface MediaGalleryProps {
  media: MediaItem[];
  name: string;
}

const MediaGallery: React.FC<MediaGalleryProps> = ({ media, name }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);

  if (!media?.length) {
    return null;
  }

  return (
    <div className="space-y-4">
      {/* Main Slider */}
      <Swiper
        modules={[Navigation, Thumbs, A11y]}
        thumbs={{ swiper: thumbsSwiper }}
        navigation={media.length > 1}
        loop={media.length > 1}
        className="aspect-video rounded-lg overflow-hidden"
      >
        {media.map((item, index) => (
          <SwiperSlide key={`main-${index}`}>
            <MediaViewer item={item} name={name} />
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Thumbnails */}
      {media.length > 1 && (
        <Swiper
          modules={[Thumbs]}
          watchSlidesProgress
          onSwiper={setThumbsSwiper}
          slidesPerView="auto"
          spaceBetween={8}
          className="h-20"
        >
          {media.map((item, index) => (
            <SwiperSlide 
              key={`thumb-${index}`}
              className="!w-32"
            >
              <div className="relative h-full rounded-lg overflow-hidden bg-background-secondary cursor-pointer">
                {item.type === 'video' ? (
                  <div className="absolute inset-0 flex items-center justify-center bg-black/50">
                    <div className="w-6 h-6 border-2 border-white rounded-full flex items-center justify-center">
                      <div className="w-0 h-0 border-l-[6px] border-l-white border-y-[4px] border-y-transparent ml-0.5" />
                    </div>
                  </div>
                ) : (
                  <img
                    src={item.url}
                    alt={`${name} thumbnail ${index + 1}`}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                )}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  );
};

export default MediaGallery;